(() => {
  const current = new URL(location.href);
  const live = !!(window.Shopify && Shopify.theme && Shopify.theme.role === 'main');
  // On the live theme, never carry a theme preview in links: a saved or shared link would open that theme as a draft once a newer copy is published.
  if (live && current.searchParams.has('preview_theme_id')) { current.searchParams.delete('preview_theme_id'); try { history.replaceState(history.state, '', current.pathname + current.search + current.hash); } catch (e) {} }
  const preview = live ? '' : (current.searchParams.get('preview_theme_id') || document.body.dataset.gThemeId);
  // Other scripts read the theme number from the page; on the live site there is none to carry.
  if (live && document.body) delete document.body.dataset.gThemeId;
  const previewHosts = new Set([location.hostname, 'www.mensuits.com', 'mensuits.com', 'mensuits-co.myshopify.com']);
  const collectionViews = new Set(['giorgio', 'giorgio-formal', 'giorgio-prom', 'giorgio-work']);
  const applyLinkContext = link => {
    const href = link.getAttribute('href');
    if (!href || href.trim().startsWith('#')) return;
    const url = new URL(link.href, location.origin);
    // Invitation/account query data and unknown fragments must retain their original destination.
    if (url.pathname === '/pages/group-orders') {
      const plainMarketingQuery = [...url.searchParams.keys()].every(key => ['view', 'preview_theme_id', 'pb', '_fd', 'g_audit'].includes(key) || key.startsWith('utm_'));
      const plainMarketingHash = ['', '#organizer', '#member', '#app-help'].includes(url.hash);
      if (!plainMarketingQuery || !plainMarketingHash) return;
    }
    if (['weddingsuits.com', 'www.weddingsuits.com'].includes(url.hostname) && url.pathname === '/pages/group-orders' && !link.closest('.g-guide-quote')) {
      url.hostname = location.hostname;
      url.pathname = '/pages/group-orders';
      url.searchParams.set('view', 'giorgio-group');
    }
    if (!previewHosts.has(url.hostname) || url.protocol !== 'https:') return;
    if (url.pathname.startsWith('/checkout') || url.pathname.startsWith('/account')) return;
    if (preview) url.searchParams.set('preview_theme_id', preview);
    else url.searchParams.delete('preview_theme_id');
    if (url.pathname === '/pages/right-fit-guarantee' && !link.closest('.g-guide-quote')) {
      url.pathname = '/pages/fit-guide';
      url.searchParams.delete('view');
    }
    if (url.pathname === '/pages/group-orders' && !link.closest('.g-guide-quote')) url.searchParams.set('view', 'giorgio-group');
    if (url.pathname.startsWith('/collections/')) {
      if (!collectionViews.has(url.searchParams.get('view'))) url.searchParams.set('view', 'giorgio');
    } else if (url.pathname === '/pages/weddings' && url.searchParams.get('view') !== 'giorgio-wedding-groups') {
      // The wedding group landing page keeps its own view; every other weddings link uses the Giorgio page.
      url.searchParams.set('view', 'giorgio');
    }
    link.href = url.href;
  };
  const applyContext = (root = document) => {
    root.querySelectorAll('a[href]').forEach(applyLinkContext);
  };
  const revealOffer = () => {
    if (location.hash === '#giorgio-offer-details') {
      const terms = document.getElementById('giorgio-offer-details');
      if (terms) terms.open = true;
    }
  };
  revealOffer();
  window.addEventListener('hashchange', revealOffer);
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (link) applyLinkContext(link);
    if (link && new URL(link.href).hash === '#giorgio-offer-details') {
      const terms = document.getElementById('giorgio-offer-details');
      if (terms) terms.open = true;
    }
  });
  applyContext();
  document.addEventListener('shopify:section:load', event => applyContext(event.target));
  document.addEventListener('giorgio:content-updated', event => applyContext(event.target));
  // Keep all links available without JS; compact mobile disclosures stay native.
  if (typeof window.matchMedia === 'function') {
  const footerMedia = window.matchMedia('(max-width: 768px)');
  const footers = [...document.querySelectorAll('[data-g-footer-disclosure]')];
  const sizeFooter = () => {
    footers.forEach(details => {
      if (!footerMedia.matches || !details.contains(document.activeElement)) details.open = !footerMedia.matches;
    });
  };
  sizeFooter();
  footerMedia.addEventListener('change', sizeFooter);
  }
  // The Shopify preview toolbar is staging UI, but still needs a frame name.
  if (String(window.Shopify?.theme?.id) === '191007326483' && window.Shopify?.theme?.role === 'unpublished') {
    const namePreviewFrame = () => {
      const frame = document.getElementById('PBarNextFrame');
      if (!frame) return false;
      if (!frame.title.trim()) frame.title = 'Shopify theme preview controls';
      return true;
    };
    if (!namePreviewFrame()) {
      const observer = new MutationObserver(() => { if (namePreviewFrame()) observer.disconnect(); });
      observer.observe(document.body, {childList: true, subtree: true});
      setTimeout(() => observer.disconnect(), 20000);
    }
  }
})();
